module.exports = __webpack_public_path__ + "static/media/logo-boxmi-header.b59878ff.svg";